import { render, staticRenderFns } from "./generic-search.vue?vue&type=template&id=42bf96f5&"
import script from "./generic-search.ts?vue&type=script&lang=js&"
export * from "./generic-search.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports